import { Injectable } from '@angular/core';
import { GridService } from '../../../../shared/services/grid.service';
import { environment } from '../../../../../environments/environment';
import { HttpRequestService } from '../../../../shared/services/http-request.service';

@Injectable()
export class MemberAnalyticsService extends GridService {
  private analyticsURL = environment.apiUrl + '/MemberCms/GetAnalytics';

  constructor(private _http: HttpRequestService) {
    super();
    this.getData = this.getMembersAnalytic;
  }

  getMembersAnalytic(requestModel) {
    const monthUrl = requestModel.month ? '?month=' + requestModel.month : '';
    const yearUrl = (requestModel.month && requestModel.year ? '&year=' + requestModel.year : '')
    const url = this.analyticsURL + monthUrl + yearUrl;

    return this._http.get(url);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/analitycs/service/member-analytics.service.ts